export default {
  customerAccept: {
    method: 'get',
    url: '/client/customer/accept',
    headers: {
      tokenInvite: ''
    }
  },
  'get-list': {
    method: 'post',
    url: '/client/customer/list'
  },
  'customer-add': {
    method: 'post',
    url: '/client/customer'
  },
  'customer-edit': {
    method: 'put',
    url: '/client/customer/ID'
  },
  'customer-delete': {
    method: 'delete',
    url: '/client/customer'
  },
  find: {
    method: 'get',
    url: '/client/customer/find?key=KEY'
  },
  checkInvitation: {
    method: 'get',
    url: '/client/customer/check-invitation',
    headers: {
      tokenInvite: ''
    }
  }
}
